export const intlCollator = new Intl.Collator('en-GB', { numeric: true, sensitivity: 'case' });

export function mapEmptyStringToUndefined(value) {
    return value === '' ? undefined : value;
}
